import pkg from "../../package.json";

export const APP_VERSION = pkg.version as string;

// Identificador del build/deploy (commit SHA en Vercel, "dev" en local).
// Inlineado al buildear vía `env` en next.config.ts. El cliente lo compara
// contra /api/version para detectar que hay un deploy más nuevo cargable
// con un refresh de página.
export const BUILD_ID = process.env.NEXT_PUBLIC_BUILD_ID ?? "dev";

// Deployment id de Vercel (dpl_...), inlineado al buildear vía `env` en
// next.config.ts. "" en local / fuera de Vercel. Lo usa deployment-pin.tsx
// para pinear los fetch() propios al deployment que sirvió este bundle.
export const DEPLOYMENT_ID = process.env.NEXT_PUBLIC_DEPLOYMENT_ID ?? "";

// Mapeado desde VERCEL_ENV en next.config.ts. En `next dev` local cae a
// "development". En deploys de Vercel: "production" | "preview" | "development".
export type AppEnv = "production" | "preview" | "development";

const RAW_ENV = (process.env.NEXT_PUBLIC_VERCEL_ENV ?? "development") as AppEnv;

export const APP_ENV: AppEnv =
  RAW_ENV === "production" || RAW_ENV === "preview" ? RAW_ENV : "development";

// Label cortito para mostrar en chips de UI.
export const APP_ENV_LABEL: Record<AppEnv, string> = {
  production: "prod",
  preview: "preview",
  development: "dev",
};
